"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = require("@microsoft/load-themed-styles");
load_themed_styles_1.loadStyles([{ "rawString": ".root_0182e669{display:inline-block}\n" }]);
exports.root = "root_0182e669";
//# sourceMappingURL=GroupSpacer.scss.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib/components/GroupedList/GroupSpacer.scss.js
// module id = 1566
// module chunks = 0